import React, { useState, useEffect } from 'react';
import ProtocolInfoContainer from 'containers/protocol/protocoldetail';
import ParticipationContainer from 'containers/protocol/participation';
import VersionsContainer from 'containers/protocol/versions';
import StudyAgentContainer from 'containers/protocol/studyagent';
import PSRSContainer from 'containers/protocol/psrs';
import CirbsContainer from 'containers/protocol/cirb';
import OpenContainer from 'containers/protocol/opensetup';
import IntegrationsContainer from 'containers/protocol/integrations';
import FundingContainer from 'containers/protocol/funding';
import AdministrationContainer from 'containers/protocol/administration';

export const SwitchComponents = ({ active, children }) => {
  return children.filter(child => child.props.name === active)
}

export const ProtocolContent = (props) => {
  const { type } = props;
  const [activeComponent, setActiveComponent] = useState();

  useEffect(() => {
    setActiveComponent(type);
  }, [type]);

  return (
    <SwitchComponents active={activeComponent}>
      <ProtocolInfoContainer name="protocoldetail" {...props} />
      <ParticipationContainer name="participation" {...props} />
      <VersionsContainer name="versions" {...props} />
      <StudyAgentContainer name="studyagent" {...props} />
      <PSRSContainer name="psrs" {...props} />
      <CirbsContainer name="cirb" {...props} />
      <OpenContainer name="opensetup" {...props} />
      <IntegrationsContainer name="integrations" {...props} />
      <FundingContainer name="funding" {...props} />
      <AdministrationContainer name="admin" {...props} />
    </SwitchComponents>
  );

}






